import { render, staticRenderFns } from "./LeaderView.vue?vue&type=template&id=66e0f158&scoped=true&"
import script from "./LeaderView.vue?vue&type=script&lang=js&"
export * from "./LeaderView.vue?vue&type=script&lang=js&"
import style0 from "./LeaderView.vue?vue&type=style&index=0&id=66e0f158&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66e0f158",
  null
  
)

export default component.exports